import { Component } from 'react';
import { Notifier as AirbrakeClient } from '@airbrake/browser';

const hostIncludes = (string) => {
  if (!window.location.host) return false;

  return window.location.host.includes(string);
};

const defaultEnv = () => {
  if (hostIncludes('staging')) {
    return 'staging';
  } else if (hostIncludes('dev')) {
    return 'development';
  }
  return 'production';
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };

    this.airbrake = new AirbrakeClient({
      projectId: process.env.REACT_APP_AIRBRAKE_PROJECT_ID,
      projectKey: process.env.REACT_APP_AIRBRAKE_PROJECT_KEY,
      environment: process.env.REACT_APP_AIRBRAKE_ENV || defaultEnv()
    });

    // Ignore errors from dev environment.
    this.airbrake.addFilter(notice => (notice.context.environment === 'development' ? null : notice));
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });

    // Send error to Airbrake
    this.airbrake.notify({ error, params: { info }});
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
